<template>
  <textarea
    class="form-control"
    :id="id"
    :disabled="props.locked"
    v-model="syncedText"
    placeholder="Type something..."
    :aria-label="props.label ?? 'goal text box'"
    rows="3"
    @blur="blur"
    @paste="blur"
    @keydown.stop="keyDown"
    data-test="goal-capture-box"
  />
</template>

<script setup lang="ts">
/* eslint-disable */
import { computed, ref, defineEmits } from "vue";
import { saveGoalInput } from "../../stores/goal-capture-store";

const props = defineProps<{ label?: string; goalNumber: number; text: string; locked: boolean }>();
const text = ref<string>("Loading...");
const loading = ref<boolean>(true);

const id = computed(() => `goal-capture-box-${props.goalNumber}`);

const emit = defineEmits(["update:goalName"]);

const syncedText = computed({
  get: () => props.text,
  set: (newValue) => {
    emit("update:goalName", newValue);
  },
});

const blur = () => saveThrottled(true);

const paste = () => {
  saveThrottled(true);
};

const keyDown = (e: KeyboardEvent) => {
  if (e.key === "Enter" || e.key === "!" || e.key === "." || e.key === "?") {
    setTimeout(() => {
      saveThrottled(true);
    }, 100);
  } else {
    setTimeout(() => {
      saveThrottled(false);
    }, 100);
  }
};

let inputTimeout = null;

async function saveThrottled(rerunPrompts: boolean) {
  if (inputTimeout !== null) {
    return;
  }

  inputTimeout = setTimeout(async () => {
    inputTimeout = null;
    saveGoalInput(syncedText.value, props.goalNumber, rerunPrompts);
  }, 1000) as any;
}
</script>

<style scoped lang="less">
// Make the textarea not have a drag handle

textarea {
  resize: none;
  font-size: 18px;
  border-radius: 5px;
}

.form-control[disabled] {
  background-color: white;
}
</style>
